import React from 'react';
import { IndividualAttendanceRate } from "../attendance.types";

interface IProps {
    data: IndividualAttendanceRate[]
    isLoading: boolean;
}

const TeamAttendanceRateChart = (props: IProps) => {

    const getAttendanceStatus = (rate: number) => {
        if (rate >= 90) return "excellent";
        if (rate >= 75) return "good";
        if (rate >= 60) return "average";
        return "poor";
    };

    return (
        <section className="pn-attendance__card team-attendance-rate">
            <div className="pn-attendance__card__header">
                <h3 className="pn-attendance__card__title">Individual Attendance Rate</h3>
                <span className="pn-attendance__card__subtitle">% of working days present this month</span>
            </div>
            <div className={'team-attendance-rate__list'}>
                {props.data.map((item) => (
                    <div
                        key={item.employeeId}
                        className="team-attendance-rate__employee"
                    >

                    <div className="team-attendance-rate__employee-name">
                        {item.employeeName}
                    </div>


                        <div className="team-attendance-rate__progress">
                            <div
                                className={`team-attendance-rate__progress-fill
                team-attendance-rate__progress-fill--${getAttendanceStatus(item.attendanceRate)}`}
                                style={{width: `${item.attendanceRate}%`}}
                            />
                        </div>
                        <span className={`team-attendance-rate__employee-rate
                         team-attendance-rate__employee-rate--${getAttendanceStatus(item.attendanceRate)}`}>
                        {item.attendanceRate}%
                    </span>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default TeamAttendanceRateChart;
